import { SpkStakingContainer } from '@/features/spk-staking/SpkStakingContainer'

export function SpkStaking() {
  return <SpkStakingContainer />
}
